
import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import TubeLabel from '@/lib/form/label/Label.vue';
import { Watch, Inject } from 'vue-property-decorator';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';
import SelectVideosModal from '@/app/components/modals/SelectVideosModal.vue';

@Component({
  name: 'recommended-videos',
  props: ['learningSetId', 'defaultList', 'sortable', 'recommended'],
  components: {
    TButton,
    TubeLabel,
    TCheckbox,
    SelectVideosModal
  }
})
export default class RecommendedVideos extends Vue {
  private recommendedVideos: any[] = [];
  private videos: any[] = [];
  private tmpList: any[] = [];
  private addLoader = false;
  private learningSetId;
  private defaultList;
  private recommended;

  mounted() {
    this.recommendedVideos = this.defaultList;
  }

  caption(uuid) {
    const video = this.videos.filter(v => v.id == uuid)[0];
    return video && (video.description || video.createdBy);
  }

  @Watch('defaultList')
  update(newValue, oldValue) {
    if (!newValue) {
      return;
    }
    this.recommendedVideos = this.defaultList;
  }

  onUpdateVideo(newIndex, oldIndex) {
    window.setTimeout(() => {
      const el = this.recommendedVideos.splice(oldIndex, 1)[0];
      this.recommendedVideos.splice(newIndex, 0, el);
      this.updateRecommendedVideos();
    });
  }

  removeVideoElement(el) {
    const index = this.recommendedVideos.indexOf(el);
    this.recommendedVideos.splice(index, 1);
    this.updateRecommendedVideos();
    // have to figure out loader
  }

  addToRecommendedVideos(videoIds) {
    videoIds.forEach(item => {
      const tmp = {
        id: item
      };
      this.recommendedVideos.push(tmp);
    });
    this.addLoader = true;
    this.updateRecommendedVideos()
      .then(() => {
        this.$modal.hide('select-videos-modal');
        this.addLoader = false;
      })
      .catch(e => {
        this.addLoader = false;
      });
  }

  showRecommendedVideosModal() {
    this.$modal.show('select-videos-modal', {
      toBeExcluded: this.recommendedVideos.map(v => v.id)
    });
  }

  updateRecommendedVideos() {
    const promise = this.recommended
      ? apiClient.updateRecommendedVideos(
          this.learningSetId,
          this.recommendedVideos.map(v => v.id)
        )
      : apiClient.updateDefaultVideos(
          this.learningSetId,
          this.recommendedVideos.map(v => v.id)
        );
    return promise
      .then(data => {
        this.$emit('resetLearningSet', data);
      })
      .catch(error => {
        this.recommendedVideos = this.defaultList;
        this.$error(error);
      });
  }
}
